(function () {
    // Everything in this file is gated behind 'twc:ready' (dispatched from scripts.liquid once
    // DOMContentLoaded fires, i.e. after this deferred script has already run and registered
    // this listener) rather than running at parse time, so all of it - including every place
    // that touches the vendor's window.theWishlist global - starts from one predictable point.
    document.addEventListener('twc:ready', function () {
        // twc:ready itself only fires at/after DOMContentLoaded (see scripts.liquid), so there's
        // no separate DOMContentLoaded to wait for here - this used to be its own listener before
        // everything got gated behind twc:ready, and left nested it would register after
        // DOMContentLoaded has already fired once and for all, meaning it would never run again.
        (function () {
            const recommendations = document.querySelector(".product-recommendations");
            if (recommendations) {
                new MutationObserver(function (mutationsList) {
                    for (const mutation of mutationsList)
                        if (
                            mutation.type === "attributes" &&
                            mutation.attributeName === "data-recommendations-performed" &&
                            recommendations.getAttribute("data-recommendations-performed") === "true"
                        ) {
                            document.body.dispatchEvent(new CustomEvent("initTheWishlist"));
                            break;
                        }
                }).observe(recommendations, { attributes: !0 });
            }

            // dy-product-recs-tabs.js swaps each skeleton's children for a fetched .product-card
            // (skeleton.replaceChildren(...)) rather than mutating the grid's own children, and it
            // only does this once per tab on first view - so watch for the .product-card node itself
            // rather than an attribute flag.
            const recsTabsCarouselGrids = document.querySelectorAll(".dy-product-recs-tabs__grid--carousel");
            recsTabsCarouselGrids.forEach(function (grid) {
                new MutationObserver(function (mutationsList) {
                    for (const mutation of mutationsList) {
                        const addedNodes = [...mutation.addedNodes];
                        if (addedNodes.some(function (n) {
                            return n instanceof Element && n.classList.contains('product-card');
                        })) {
                            dispatchWishlistEvent();
                            break;
                        }
                    }
                }).observe(grid, { childList: true, subtree: true });
            });

            // cart-recommendations.js (.cart-recommendations__grid on the cart page) swaps each
            // skeleton's children for a fetched .product-card the same way (skeleton.replaceChildren
            // (...)), but does it on every cart line item add/remove/qty change too - see
            // #reloadRecommendations in cart-recommendations.js. The grid node persists across those
            // reloads, so one observer set up here keeps catching every later swap.
            const cartRecommendationsGrids = document.querySelectorAll(".cart-recommendations__grid");
            cartRecommendationsGrids.forEach(function (grid) {
                new MutationObserver(function (mutationsList) {
                    for (const mutation of mutationsList) {
                        const addedNodes = [...mutation.addedNodes];
                        if (addedNodes.some(function (n) {
                            return n instanceof Element && n.classList.contains('product-card');
                        })) {
                            dispatchWishlistEvent();
                            break;
                        }
                    }
                }).observe(grid, { childList: true, subtree: true });
            });

            // dy-plp.js (collection/search product grid) fills each server-rendered
            // [data-dy-skeleton] placeholder the same way (skeleton.replaceChildren(...) with a
            // fetched .product-card), including on the very first page load - not just on
            // filter/sort/pagination. The aria-busy observer below also catches this grid, but only
            // once dy-plp.js's own busy-tracking toggles the attribute; watching for the
            // .product-card node directly (the same reliable signal used for recs above) doesn't
            // depend on that second mechanism agreeing, so wishlist buttons on freshly-filled
            // collection cards get bound even if the aria-busy toggle is missed or delayed.
            const productGrids = document.querySelectorAll(".product-grid");
            productGrids.forEach(function (grid) {
                new MutationObserver(function (mutationsList) {
                    for (const mutation of mutationsList) {
                        const addedNodes = [...mutation.addedNodes];
                        if (addedNodes.some(function (n) {
                            return n instanceof Element
                                && (n.classList.contains('product-card') || !!n.querySelector?.('.product-card'));
                        })) {
                            dispatchWishlistEvent();
                            break;
                        }
                    }
                }).observe(grid, { childList: true, subtree: true });
            });
        })();

        // Cart / cart-drawer "Move to Wishlist" button: injected by the third-party wishlist
        // app's own script inside .cart-items__details, which sits inside the real
        // <form id="cart-form" method="post"> (shared by the cart page and cart drawer). As a
        // <button> with no explicit type, it defaults to type="submit" - clicking it submits
        // the cart form and reloads the page. preventDefault() stops that default submit
        // without touching the vendor's own click handler on the same element.
        document.addEventListener('click', function (event) {
            const moveToWishlistButton = event.target instanceof Element
                ? event.target.closest('.cart-items__details .osc-css.wrapper-button-collection button')
                : null;
            if (moveToWishlistButton) {
                event.preventDefault();
            }
        });

        // Add/remove wishlist toggle click (.button-collection-wishlist, rendered by
        // snippets/twc-wishlistbutton.liquid on PLP cards, the PDP gallery, and cart lines). The
        // third-party wishlist app's own click handler on this button performs the whole add/remove
        // itself (POST to wh-fe.*.thewishlist.io/.../add-product-to-wishlist) against its own internal
        // state, without telling the theme it's done and without touching the button's own DOM (a
        // MutationObserver on the button never fired) - so the header .count-item
        // (twc-launchpoint.liquid, listening for initTheWishlist) previously only refreshed by
        // coincidence, whenever some unrelated trigger (grid re-sort, cart update) happened to fire
        // afterwards, or on a full page reload. Poll the vendor's own countItemWishlist() instead: once
        // it reports a different count than it did right before the click, the vendor has finished
        // updating its state and it's safe to dispatch. Bails out after 5s so a failed/no-op request
        // (count unchanged) doesn't poll forever.
        document.addEventListener('click', function (event) {
            const wishlistButton = event.target instanceof Element
                ? event.target.closest('.button-collection-wishlist')
                : null;
            if (!wishlistButton) return;

            function readCount() {
                const wishlist = /** @type {any} */ (window).theWishlist;
                try {
                    return wishlist && typeof wishlist.countItemWishlist === 'function'
                        ? wishlist.countItemWishlist()
                        : undefined;
                } catch {
                    return undefined;
                }
            }

            const startCount = readCount();
            let attempts = 0;
            const poll = setInterval(function () {
                attempts += 1;
                const currentCount = readCount();
                if (currentCount !== undefined && currentCount !== startCount) {
                    clearInterval(poll);
                    dispatchWishlistEvent();
                } else if (attempts >= 25) {
                    clearInterval(poll);
                }
            }, 200);
        });

        // The third-party wishlist app sets its own title (e.g. "Add to wishlist") on
        // .button-collection-wishlist (snippets/twc-wishlistbutton.liquid), producing a native
        // browser tooltip we don't want - and there's no CSS way to suppress a native title
        // tooltip, so this has to be stripped in JS. The vendor renders the button (title already
        // included) as a whole node rather than calling setAttribute on an existing one, so this
        // shows up as a childList mutation, not an attributes one - re-scan on every mutation
        // batch instead of relying on attributeFilter.
        function stripWishlistButtonTitles() {
            document.querySelectorAll('.button-collection-wishlist[title]').forEach(function (button) {
                button.removeAttribute('title');
            });

            // The vendor also (re-)renders its own heart icon markup inside the button on
            // product-grid/PDP buttons - complete with its own SVG <title>Heart</title>, which
            // produces the same native tooltip on hover. Strip that too, wherever it shows up.
            document.querySelectorAll('.button-collection-wishlist title').forEach(function (title) {
                title.remove();
            });
        }
        stripWishlistButtonTitles();
        new MutationObserver(stripWishlistButtonTitles).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['title']
        });

        // Re-init the wishlist whenever the cart changes (add/remove/qty update, from any
        // source - product form, quick add, the wishlist's own add-to-cart, etc). Cart line
        // items re-render on every update, which can bring in fresh "Move to Wishlist"
        // buttons that need (re)binding. Wait for event.promise so this runs after the new
        // cart content is actually in the DOM, not at the moment the update merely started.
        document.addEventListener('shopify:cart:lines-update', function (event) {
            const promise = /** @type {any} */ (event).promise;
            if (promise && typeof promise.then === 'function') {
                promise.then(dispatchWishlistEvent).catch(dispatchWishlistEvent);
            } else {
                dispatchWishlistEvent();
            }
        });

        // Re-init the wishlist after a combined-listing colour swatch swap (variant-picker.js,
        // morphElementSelector: 'main'). That swap can morph in a wishlist button tied to a
        // completely different underlying product (combined listings link separate real
        // products, not variants of one product) - the vendor's own script is still holding
        // onto whatever it bound at page load, so without a re-init it keeps referencing the
        // pre-swap product's data ("Cannot read properties of null (reading 'variants')" is the
        // vendor script failing to find/parse that stale reference against the swapped-in
        // button). Wait for event.promise so this runs after the morph has actually landed.
        document.addEventListener('shopify:product:select', function (event) {
            const promise = /** @type {any} */ (event).promise;
            if (promise && typeof promise.then === 'function') {
                promise.then(dispatchWishlistEvent).catch(dispatchWishlistEvent);
            } else {
                dispatchWishlistEvent();
            }
        });

        // PLP wishlist elements
        /** @type {ReturnType<typeof setTimeout>} */
        let productGridDebounce;

        function dispatchWishlistEvent() {
            clearTimeout(productGridDebounce);

            productGridDebounce = setTimeout(function () {
                const wishlist = /** @type {any} */ (window).theWishlist;
                if (wishlist && typeof wishlist.init === 'function') {
                    wishlist.init();
                }
                document.body.dispatchEvent(new CustomEvent('initTheWishlist'));
            }, 150);
        }

        // Sort/filter/pagination can go through either Dynamic Yield's own pagination
        // (dy-plp.js / dy-search.js, which toggles aria-busy on .product-grid) or Shopify's
        // native facets/section-rendering path (facets.js), which morphs the whole section
        // and can replace the .product-grid node outright. An observer attached to one
        // captured grid element stops firing the instant that element is swapped out - so
        // watch a stable ancestor (document.body) with subtree:true instead of the grid
        // itself, which keeps working across replacement, and re-check with a live
        // querySelector rather than trusting the mutation's own target reference.
        new MutationObserver(function (mutationsList) {
            for (const mutation of mutationsList) {
                if (mutation.type !== 'attributes' || mutation.attributeName !== 'aria-busy') continue;
                const target = /** @type {Element} */ (mutation.target);
                if (target.classList?.contains('product-grid') && !target.hasAttribute('aria-busy')) {
                    dispatchWishlistEvent();
                    break;
                }
            }
        }).observe(document.body, {
            attributes: true,
            attributeFilter: ['aria-busy'],
            subtree: true
        });

        // Native Shopify facets/sort/filter/pagination completion - fires regardless of
        // whether the section morph replaced .product-grid, since we don't hold a node
        // reference at all here.
        ['shopify:search:update', 'shopify:collection:update'].forEach(function (eventName) {
            document.addEventListener(eventName, function (event) {
                const promise = /** @type {any} */ (event).promise;
                if (promise && typeof promise.then === 'function') {
                    promise.then(dispatchWishlistEvent).catch(dispatchWishlistEvent);
                } else {
                    dispatchWishlistEvent();
                }
            });
        });

        window.addEventListener('load', function () {
            dispatchWishlistEvent();
        });

        // wishlist page format price
        /**
         * @param {NodeListOf<HTMLElement>} elements
         */
        function formatPriceText(elements) {
            elements.forEach(function (element) {
                if (element.dataset.processed === "true") return;

                const text = element.textContent || '';

                // Extract numeric value only (handles 105.00, 140, etc)
                const match = text.match(/([\d,.]+)/);
                if (!match || !match[1]) return;

                const value = parseFloat(match[1].replace(',', ''));

                // Carry over the currency code if the vendor's own text already included one
                // (e.g. "$140.95 AUD") - avoids depending on anything outside this file.
                const currencyMatch = text.match(/\b([A-Z]{3})\b/);
                const currency = currencyMatch && currencyMatch[1] ? currencyMatch[1] : '';

                // Format as $140.95 AUD
                element.textContent = `$${value.toFixed(2)}${currency ? ' ' + currency : ''}`;

                element.dataset.processed = "true";
            });
        }

        const observer = new MutationObserver(() => {
            // .product-price can wrap two separate prices - .price-compare-at ("was") and
            // .price ("now") - formatting the wrapper's own textContent concatenates both
            // into one mangled line (e.g. "Price: 329.95 AUD" + "Now: 179.00 AUD" collapsed
            // into a single garbled value). Format each price span on its own instead, and
            // only fall back to the wrapper itself when it has neither child span (a single
            // bare price with nothing to collapse).
            const elements = /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll(
                '.ucwl-osc-css .product-price .price-compare-at:not([data-processed]),'
                + ' .ucwl-osc-css .product-price .price:not([data-processed]),'
                + ' .ucwl-osc-css .product-price:not(:has(.price, .price-compare-at)):not([data-processed])'
            ));
            formatPriceText(elements);
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Feature flag: temporarily disables the auto-preselect-default-wishlist behavior below
        // (kept in place, not removed, in case we want it back) in favor of forcing a manual
        // selection instead - see the unconditional clearing logic further down.
        const AUTO_PRESELECT_DEFAULT_WISHLIST = false;

        // Wishlist "add to list" modal (.wishlist-list / .variant-item-list, vendor-rendered): the
        // vendor already marks the default wishlist with data-wishlist-default="true" on its
        // input.wishlist-list-input, but never actually checks it itself, so the modal opens with
        // nothing pre-selected. The list is rendered fresh into the DOM each time the modal opens,
        // so react to it being inserted rather than polling - check the default input the moment it
        // appears, and fire a 'change' event so the vendor's own selection-tracking (bound the same
        // way a real click would trigger it) picks up the pre-selection too. Only auto-check it when
        // nothing in the list is already checked (e.g. the vendor remembering the last-selected
        // wishlist) - don't clobber an existing selection.
        const wishlistListObserver = new MutationObserver(function (mutationsList) {
            for (const mutation of mutationsList) {
                const addedNodes = [...mutation.addedNodes];
                const listNode = /** @type {Element | undefined} */ (addedNodes.find(function (n) {
                    return n instanceof Element && (
                        n.matches?.('.wishlist-list, .variant-item-list') ||
                        n.querySelector?.('.wishlist-list, .variant-item-list')
                    );
                }));
                if (!listNode) continue;

                // Force a manual selection instead: the vendor can render this modal with a variant
                // and/or wishlist already pre-checked (e.g. defaulting to the first variant, or
                // remembering the last-selected wishlist), which leaves the Confirm button enabled
                // without the user actually choosing anything. Clear both so the user has to pick a
                // variant and a wishlist before the vendor's own click-driven logic enables Confirm.
                //
                // Only do this once per modal instance (flagged via data-wishlist-selection-cleared on
                // the modal-document wrapper) - the vendor re-renders these lists on every selection to
                // reflect the new checked state, and that re-render is itself a childList mutation
                // matching this same observer. Without the flag, clearing on every match would wipe out
                // the user's own click the instant they made it, making it impossible to select anything.
                const modalContainer = listNode.closest?.('.modal-document') || listNode;
                const alreadyClearedThisModal = modalContainer instanceof HTMLElement
                    && modalContainer.dataset.wishlistSelectionCleared === 'true';
                if (modalContainer instanceof HTMLElement) {
                    modalContainer.dataset.wishlistSelectionCleared = 'true';
                }
                if (!alreadyClearedThisModal) {
                    document.querySelectorAll(
                        '.variant-item-list .variant-item input:checked, .wishlist-list .wishlist-list-input:checked'
                    ).forEach(function (input) {
                        /** @type {HTMLInputElement} */ (input).checked = false;
                    });
                }

                // Keep Confirm disabled whenever a required selection is missing. Re-selecting a
                // variant makes the vendor re-render .wishlist-list back to nothing checked, but the
                // vendor only re-disables Confirm in response to a user click on a list item - not its
                // own re-render - so without this the button stays enabled from the earlier selection
                // even though the wishlist is no longer actually selected.
                const hasVariantList = !!document.querySelector('.variant-item-list');
                const hasVariantChecked = !hasVariantList
                    || !!document.querySelector('.variant-item-list .variant-item input:checked');
                const hasWishlistChecked = !!document.querySelector('.wishlist-list input.wishlist-list-input:checked');
                if (!hasVariantChecked || !hasWishlistChecked) {
                    const confirmButton = document.querySelector('.modal-footer button.btn-save');
                    if (confirmButton) {
                        confirmButton.classList.add('disable');
                        confirmButton.setAttribute('disabled', '');
                    }
                }

                if (!AUTO_PRESELECT_DEFAULT_WISHLIST) continue;

                const alreadyChecked = document.querySelector('.wishlist-list input.wishlist-list-input:checked');
                if (alreadyChecked) continue;

                const defaultInput = /** @type {HTMLInputElement | null} */ (document.querySelector(
                    '.wishlist-list input.wishlist-list-input[data-wishlist-default="true"]'
                ));
                if (defaultInput) {
                    defaultInput.checked = true;
                    defaultInput.dispatchEvent(new Event('change', { bubbles: true }));
                }

                // The vendor only enables the Confirm button in response to a user click on a
                // wishlist-list item, not the synthetic 'change' event above, so the button is left
                // disabled even though a wishlist is now selected. Clear its disabled state to match.
                const confirmButton = document.querySelector('.modal-footer button.btn-save');
                if (confirmButton) {
                    confirmButton.classList.remove('disable');
                    confirmButton.removeAttribute('disabled');
                }
            }
        });

        wishlistListObserver.observe(document.body, {
        childList: true,
        subtree: true
        });

        // Same reasoning as above: twc:ready already implies DOMContentLoaded has fired, so this
        // no longer waits on its own now-unfireable DOMContentLoaded listener.
        (function () {
            document.body.addEventListener("wishlistAddToCartEvent", function (event) {
                const e = /** @type {CustomEvent} */ (event);
                const productId = e.detail?.productId ?? null;
                const variantId = e.detail?.variantId ?? null;
                const quantity = e.detail?.quantity || 1;

                // Matches the shape @shopify/events' CartLinesUpdateEvent produces (action/promise
                // as top-level properties on the event, not nested in `.detail`) so the theme's own
                // cart-drawer.js / cart-icon.js / header-actions.js listeners react to it the same
                // way they do for a native add-to-cart. Built manually rather than imported since
                // this script isn't loaded as a module.
                /** @type {any} */
                const cartLinesUpdateEvent = new CustomEvent("shopify:cart:lines-update", {
                    bubbles: true,
                    cancelable: true,
                });
                cartLinesUpdateEvent.action = "add";
                cartLinesUpdateEvent.context = "wishlist";
                cartLinesUpdateEvent.promise = fetch("/cart.js")
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (cart) {
                        return {
                            cart: {
                                totalQuantity: cart.item_count,
                            },
                            detail: {
                                didError: false,
                                source: "wishlist",
                                sourceId: "wishlist",
                                productId: productId,
                                variantId: variantId,
                                itemCount: quantity,
                            },
                        };
                    })
                    .catch(function () {
                        return {
                            cart: null,
                            detail: {
                                didError: true,
                                source: "wishlist",
                                sourceId: "wishlist",
                                productId: productId,
                                variantId: variantId,
                                itemCount: quantity,
                            },
                        };
                    }); 

                document.dispatchEvent(cartLinesUpdateEvent);

                const cartDrawer = document.querySelector("cart-drawer-component");
                const themeDrawer = /** @type {any} */ (cartDrawer?.closest("theme-drawer"));
                themeDrawer?.open?.();
            });
        })();
    });
})();
